import Vue from 'vue';
import VueRouter from 'vue-router';
import api from './api/api';
import { routes } from './routes';

Vue.use(VueRouter);

const router = new VueRouter({ routes });

router.beforeEach((to, from, next) => {
    if (window.newVueApp) {
        window.newVueApp.$bus.$off('barcode-scan');
    }

    const target =
        to.matched && to.matched.length > 0 ? to.matched[0].path : to.path;

    const valid = window.vuexStore.getters['currentUser/isValidLogin'];
    const targetIsLogin = target.indexOf('/login') === 0;

    let fullRouteDefinition = routes.find((x) => x.path === target);
    if (!fullRouteDefinition) {
        fullRouteDefinition = routes.find((x) => target.startsWith(x.path));
    }

    window.vuexStore.commit('general/setPageTitle', fullRouteDefinition.title, {
        root: true,
    });

    const classList = window.document.body.classList;
    if (classList.contains('disable-scroll')) {
        classList.remove('disable-scroll');
    }
    if (fullRouteDefinition.disableScroll) {
        classList.add('disable-scroll');
    }

    // Cancel all requests
    api.cancelRequests();

    if (!targetIsLogin && !valid) {
        // Go to login with a redirect back to the requested page
        const loginRedirect =
            to.fullPath !== '/menu'
                ? '/login?url=' + to.fullPath.slice(1)
                : '/login';

        next(loginRedirect);
    } else {
        next();
    }
});

router.afterEach((to, from) => {
    window.scrollTo(0, 0);

    // Skip cache refresh for some routes
    if (!to.skipProductTypeCache) {
        window.vuexStore.dispatch(
            'productTypesCache/refreshProductTypesDelayed',
            { forceCheck: false },
            { root: true }
        );
    }
});

export default router;
